import { formatDate } from 'lib/util/date-time';

import { IVariantClassificationListItem } from '../types';
import { formatNomenclaturesToDisplay } from '../utils';

import { VariantClassificationField } from './constants';

export function formatVariantClassification(variantClassification: IVariantClassificationListItem) {
  const {
    classification_unit,
    classification,
    created_at,
    interpreted_at,
    updated_at,
    last_reviewed_at,
    reviewed_at,
    state,
  } = variantClassification;
  const { variant, effect, nomenclatures } = classification_unit;
  const { gene, exon, allele_fraction_summary } = variant;
  const formattedNomenclatures = formatNomenclaturesToDisplay(nomenclatures, variant.is_cnv);

  return {
    [VariantClassificationField.ID]: variantClassification.id,
    [VariantClassificationField.CREATED]: created_at && formatDate(created_at),
    [VariantClassificationField.LAST_REVIEWED]: last_reviewed_at && formatDate(last_reviewed_at),
    [VariantClassificationField.INTERPRETED]: interpreted_at && formatDate(interpreted_at),
    [VariantClassificationField.UPDATED]: updated_at && formatDate(updated_at),
    [VariantClassificationField.REVIEWED]: reviewed_at && formatDate(reviewed_at),
    [VariantClassificationField.GENE]: gene,
    [VariantClassificationField.VARIANT]: formattedNomenclatures,
    [VariantClassificationField.EFFECT]: effect,
    [VariantClassificationField.EXON]: exon,
    [VariantClassificationField.CLASSIFICATION]: classification,
    [VariantClassificationField.STATE]: state,
    [VariantClassificationField.MEDIAN_ALLELE_FRACTION]: allele_fraction_summary,
  };
}
